import { render, staticRenderFns } from "./WorkOrderDetails.vue?vue&type=template&id=b20743a2&scoped=true"
import script from "./WorkOrderDetails.vue?vue&type=script&lang=js"
export * from "./WorkOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderDetails.vue?vue&type=style&index=0&id=b20743a2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20743a2",
  null
  
)

export default component.exports